export default `float e = 1.;
  for( int i=0;i++<9; ){
    p = abs( p ) - .2;
    p = p.x > p.y ? p.zxy : p.zyx;
    p *= 2.0;
    e *= 2.0;
    p.xz *= rotate2D( 2.6 );
    p.yx = abs( p.yx ) - 4.0;
  }
  p /= e;
  return e = length( p ) * .8 - .01;
}`